// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qr-1";
export var stateContainer = "_qr-0";